export default function ContactInfo() {
  return (
    <div className="flex flex-col md:flex-row gap-10">
      {/* Address */}
      <div className="md:w-1/2">
        <p className="font-semibold text-gray-800 mb-2">Διεύθυνση:</p>
        <p className="text-gray-600 leading-relaxed">
          Βιομηχανική Περιοχή Ανατολικού<br />
          Τ.Κ. 8501, Πάφος – Κύπρος<br />
          Τ.Θ. 62410, Τ.Τ. 8064
        </p>
      </div>

      {/* IT Department */}
      <div className="md:w-1/2">
        <p className="font-bold text-gray-900 text-lg mb-4">Τμήμα Πληροφορικής</p>

        <div className="mb-4">
          <p className="text-gray-800">
            <span className="font-bold">Δημήτρης Δημητρίου</span>
            {" – "}Διευθυντής Πληροφορικής
          </p>
          <p className="text-gray-600 mt-1">
            Mobile: +357 99 622 475
            <br />
            <a
              href="mailto:demetris.d@kedifap.com"
              className="text-kedifapgreen-400 hover:underline"
            >
              demetris.d@kedifap.com
            </a>
          </p>
        </div>

        <div>
          <p className="text-gray-800">
            <span className="font-bold">Ιωάννης Κρητικός</span>
            {" – "}Λειτουργός Πληροφορικής
          </p>
          <p className="text-gray-600 mt-1">
            Direct: +357 26 822 698
            <br />
            <a
              href="mailto:ioannis.k@kedifap.com"
              className="text-kedifapgreen-400 hover:underline"
            >
              ioannis.k@kedifap.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
